// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const textEncoder = {
  convert(input) {
    return new TextEncoder().encode(input);
  }
};
export { textEncoder };
